<template>
    <VPanel class="panel--layer panel--navigation" @close="close" v-if="visible">
        <VButton class="panel__button panel__button--back" @click="close">
            <ArrowLeftSvg></ArrowLeftSvg>

            <span>{{ t('go-back') }}</span>
        </VButton>

        <div class="panel__scroll">
            <slot :close="close" :open="open" :visible="visible"></slot>
        </div>
    </VPanel>
</template>

<script setup lang="ts">
// Svg
import ArrowLeftSvg from '@/assets/arrow-left.svg';

// Components
import VPanel from './VPanel.vue';
import VButton from './VButton.vue';

// Other
import { defineEmits, defineProps } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const emit = defineEmits(['update:visible']);
defineProps({
    header: { type: Boolean, default: false },
    visible: { type: Boolean, default: false },
    navigation: { type: Boolean, default: false },
});

function open() {
    emit('update:visible', true);
}

function close() {
    emit('update:visible', false);
}
</script>

<style lang="scss">
.panel {
    &--layer {
        position: absolute;
        display: flex;
        flex-direction: column;
        width: 100%;
        height: 100%; // DON'T TOUCH
        background-color: var(--background-color);
        --background-color: inherit;
        z-index: 1;
    }

    &--navigation {
        padding-top: 3.5rem;
    }

    &__button {
        &--back {
            position: absolute;
            top: 0.5rem;
            left: 0.5rem;
            padding: 0.5rem;
            @include h6();
            line-height: 1.5rem;
            color: var(--brand-green);

            & svg {
                margin-right: 0.5rem;
            }

            @media (min-width: #{$breakpoint-tablet + 1}) {
                left: 1rem;
            }
        }
    }
}
</style>
